/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react";
import useSelect from "~components/Form/hooks/useSelect";
import prepareForOptions from "~services/utils/prepareForOptions";
import { useLiveQuery } from "dexie-react-hooks";
import { db } from "~/db/db";

const useProdutoConcorrente = ({ formikRef, name = 'produtoConcorrenteId' }) => {
  const produtoConcorrenteSelect = useSelect("produto");
  const [produtoConcorrente, setFunilObraProduto] = useState(0);

  const [produtoConcorrentes, setProdutoConcorrentes] = useState([]);

  useEffect(() => {
    const fetchProdutoConcorrentes = async () => {
      const produtoConcorrentesTemp = [];
      await db.produtosConcorrente.each(item => produtoConcorrentesTemp.push(item));
      setProdutoConcorrentes(produtoConcorrentesTemp);
    };

    fetchProdutoConcorrentes();
  }, []);


  const optionFunilObraProdutos = useMemo(() => prepareForOptions(produtoConcorrentes, 'nome', 'id'), [produtoConcorrentes]);

  function onChangeFunilObraProduto(e) {
    produtoConcorrenteSelect.upDateValue(e.value);
    produtoConcorrenteSelect.upDateDefaultValue(e || "");
    if (formikRef?.current) {
      formikRef.current.setFieldValue(name, e.value);
      setTimeout(() => formikRef.current.setFieldTouched(name, true));
    }
    setFunilObraProduto(e.value);
  }

  function SetSelectFunilObraProduto(id) {
    const produtoConcorrente = optionFunilObraProdutos.find((o) => o.value === id);
    if (produtoConcorrente) {
      onChangeFunilObraProduto(produtoConcorrente);
    }
  }

  function CleanForFilter(option) {
    onChangeFunilObraProduto(option);
  }

  return {
    produtoConcorrentes,
    optionFunilObraProdutos,
    onChangeFunilObraProduto,
    SetSelectFunilObraProduto,
    produtoConcorrente,
    produtoConcorrenteSelect,
    setFunilObraProduto,
    CleanForFilter,
  };
}

export default useProdutoConcorrente;